import { highestAssignedSSR, highestAssignedUOS } from './highestAssigned';

export const derivePanelCounts = (switches, storedUOS, storedSSR) => {
  const atLeast = (stored, derived) => {
    const best = Math.max(Number(stored) || 0, derived);
    return best > 0 ? best : '';
  };

  return {
    numOfUOS: atLeast(storedUOS, highestAssignedUOS(switches)),
    numOfSSR: atLeast(storedSSR, highestAssignedSSR(switches)),
  };
};
